/* src/app/shared-module/components/skeleton-components/skeleton-property-detail/skeleton-property-detail.component.scss */
.img-card {
  border-radius: 20px;
  margin: 10px;
  padding: 0px;
  box-shadow: none;
}
.img-card1 {
  border-radius: 20px;
  margin: 0px 10px 0px 10px;
  padding: 0px;
  box-shadow: none;
}
.main-card-content {
  background-color: var(--ion-color-primary-tint);
  border-radius: 20px;
  margin: 0px;
  padding: 0px;
  box-shadow: none;
}
.main-card-content {
  background-color: var(--ion-color-primary-tint);
  border-radius: 20px;
  margin: 10px 10px 10px 10px;
  padding: 0px;
  box-shadow: none;
}
/*# sourceMappingURL=skeleton-property-detail.component.css.map */
